// copy from sharePopup
import React, { useEffect, useState } from 'react';
import SearchBar from '../explore/searchBar/searchBar';
import {useTranslation} from "react-i18next";
import {getAllUser} from "../api"

function UserItem({user}){
    const {id,img, firstname, lastname} = user;

    let span;
    let contact_img;

    if(img === undefined || img === null){
	contact_img = <span className="c-contact_img-replace">{firstname[0].toUpperCase()}{lastname[0].toUpperCase()}</span>
    }else{
	contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={img} />
    }

    return <div className="c-contact_infos">
      {contact_img}
      <div className="c-infos">
	<p>{firstname} {lastname}</p>
	{ span }
      </div>
    </div>
}



function UserModal({dataList, onClick, onClose}) {
    const { t } = useTranslation();

    const [search, setSearch] = React.useState("");
    const [selected,setSelected] = React.useState([]);
    const [filterDisplay, setFilterDisplay] = React.useState([]);

    useEffect(() => {
        setSearch(search);
        let oldList = dataList;

        if(search !== ""){
            let newList = [];
            newList = oldList.filter(c =>
                c.firstname.toUpperCase().includes(search.toUpperCase()) || c.lastname.toUpperCase().includes(search.toUpperCase())
            );
            setFilterDisplay(newList);
        }else{
            setFilterDisplay(dataList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const handleChange = event => {
        setSearch(event);
    }

    const onValidate = () => {
      onClick(selected[0])
    }

    const CheckableUserItem = ({user}) => {
      function handleChange(event, item){
	  const isChecked = event.target.checked;
	  if(isChecked){
	      // setSelected([...selected, item.id]);
	      setSelected([item.id]);
	  }else{
	      let newList = selected.filter(c =>
		  c !== item.id
	      );
	      setSelected(newList);
	  }
      }

      return <div className={`c-contact`}>
	  <UserItem user={user} />
	  <input type="checkbox" className="c-contact_checkbox" name="contacts" checked={selected.includes(user.id)} onChange={(e) => handleChange(e, user)}/>
      </div>
    }

    let data_list = [];
    if(search.length < 1){
        data_list = dataList;
    }else{
        data_list = filterDisplay;
    }

    let view;

        view = <>
            <div className="c-popup_searchbar">
                <SearchBar value={search} handleChange={e => handleChange(e.target.value)}/>
            </div>
            <div className="c-popup_search">
                {
                    data_list.map(c => {
                        return <CheckableUserItem user={c} key={c.id} />
                    })}
            </div>
        </>

    return <div className={`c-container_bg active`}>
	<div className="c-popup_div">
	    <div className="c-popup_header">
		<span className="c-popup_close" onClick={onClose} />
		<p>{t("Set a new owner")}</p>
		<button type="button" className="c-valid_button" onClick={onValidate}>{t("Save")}</button>
	    </div>
	    <div className="c-popup_content">
		{ view }
	    </div>
	</div>
    </div>
}



export {UserItem, UserModal};

